export const NO_THEME_TOKEN = '__nt__';
export const ALLOW_THEME_TOKEN = '__at__';

const allowedThemeExtensions = /\.(svg)$/;
export function isAllowedToTransform(fileName: string): boolean {
  return allowedThemeExtensions.test(fileName) && !fileName.includes(NO_THEME_TOKEN);
}

export const SCHEMES = ['dark', 'light'] as const;
export const BRANDS = ['bluish', 'pinkish', 'reddish'] as const;

export type Scheme = (typeof SCHEMES)[number];
export type Brand = (typeof BRANDS)[number];

export type ParsedOverride = {
  readonly baseName: string;
  readonly scheme: Scheme;
  readonly brand?: Brand;
};

const OVERRIDE_PATTERN = /_theme=([^_.]+)(?:_([^_.]+))?(\.[^.]+)$/;

export function parseOverrideFileName(fileName: string): ParsedOverride | null {
  const match = OVERRIDE_PATTERN.exec(fileName);
  if (match == null) {
    return null;
  }

  const [, schemeStr, brandStr, extension] = match as unknown as [string, string, string | undefined, string];

  if (!SCHEMES.includes(schemeStr as Scheme)) {
    return null;
  }

  const scheme = schemeStr as Scheme;

  if (brandStr !== undefined && !BRANDS.includes(brandStr as Brand)) {
    return null;
  }

  const brand = brandStr as Brand | undefined;
  const baseName = fileName.replace(OVERRIDE_PATTERN, extension);

  return { baseName, scheme, brand };
}

export function isOverrideFile(fileName: string): boolean {
  return parseOverrideFileName(fileName) != null;
}
